// utils
import React, { useEffect, useState } from "react";
import {useMatch, Link, useParams} from "react-router-dom";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../utils/langUtils";
import { setImage } from "../components/setImage";
import { globalLoading } from "../../../components/global";
import { parseIsoDatetime } from "../components/parseIsoDateTime";
import { article404ContainerHeight } from "../components/article404ContainerHeight";
import { articleContainerHeight } from "../components/articleContainerHeight";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// files

// sections
import SectionLoadingError from "../../../components/section-loading-error/section-loading-error";

import square_lemon from "../../../files/icons/rency/square_lemon.svg";
import square_lime from "../../../files/icons/rency/square_lime.svg";
import square_grass from "../../../files/icons/rency/square_grass.svg";


// storage for DATA obtained from backend
let article: any = null;
let requestErrorCode = "";
let requestErrorText = "";

/**
 * ARTICLE page
 * @params clicked article URL that will be requested from backend
 * @returns ARTICLE page
 */
export default function Article() {
    // to get ARTICLE URL from parameter in URL query
    const queryString = window.location.search;
    // the URL that needs to be requested from INTERNAL SYSTEM via our SERVER
    const { url } = useParams();

    const [isLoaded, setIsLoaded] = useState(false)
    const [requestError, setRequestError] = useState(false);
    
    useEffect(() => {
        articleContainerHeight();
    })
    window.addEventListener("resize", (event) => {
        articleContainerHeight();
    });

    // On PAGE load DATA from backend are REQUESTED 
    useEffect(() => {
        
        // Sets GLOBAL LOADING to TRUE 
        globalLoading.switch();
         
        axios.get("/api/blog/getArticle/", { params: { lang: language, url: url }, timeout: 10000 })
            .then(function (response) {
                article = response.data.data;
                
                // DEBUG - simulates waiting for DATA - used for DEBUGGING purposes
                //window.setTimeout(() => {globalLoading.switch();}, 5000);
                
                // Sets GLOBAL LOADING to FALSE 
                globalLoading.switch();
                setIsLoaded(true);
    
            })
            .catch(function (error) {
                // Sets GLOBAL LOADING to FALSE
                globalLoading.switch();

                // DEBUG whole error message
                //console.log(error);
                
                // error response from backend
                if(error?.response?.status >= 400 && error?.response?.status <= 599)
                {
                    console.log("status err:", error.response.status, error.response.statusText);
                    requestErrorCode = error.response.status.toString();
                    requestErrorText = error.response.statusText.toString();
                }
                // response from backend timeout
                else
                {
                    console.log("status err: 408 Request Timeout");
                    requestErrorCode = "408";
                    requestErrorText = "Request Timeout";
                }
                setRequestError(true);
                console.log(requestError);
            });
    }, [])

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";

    let translation= translation_cs;

    let language = getCurrentLanguage(lang);
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }
    
    useEffect(() => {
        article404ContainerHeight();
    })
    window.addEventListener("resize", (event) => {
        article404ContainerHeight();
    });

    /**
     * Used for pressing HTML string content of the ARTICLE into html (react was showing whole HTML code as string without interpretation)
     * @param content HTML string
     * @returns HTML
     */
    function createMarkup(content:any) {
        return {__html: content};
    }

    return (
        <div id="articleContainer">
            { requestError ? 
                <>
                    <SectionLoadingError requestErrorCode={requestErrorCode} requestErrorText={requestErrorText} reloadAddress={getUrlPrefix(language) + "blog"}></SectionLoadingError>
                </>
                : 
                <></>
            }
            {isLoaded ? (
                <>  
                    <div className="article-hero-section navbar-size-compensation">
                        <div className="pt-3 pt-lg-5"></div>
                        <div className="pt-3 pb-3 pt-lg-5 pb-lg-5">
                            <Container>
                                <Row>
                                    <Col xs={12} sm={12} md={"auto"} className="col-12 col-md-auto pe-md-0">
                                        <ul className="article-categories paragraph-small" >
                                            { article.tags.slice(0, 1).map((tag:any) => (<li><Link to={ getUrlPrefix(language) + "blog/tag/" + tag }>{ tag }</Link></li>)) }
                                            { article.tags.slice(1).map((tag:any) => (<li> ⋅ <Link to={ getUrlPrefix(language) + "blog/tag/" + tag }>{ tag }</Link></li>)) }
                                        </ul>
                                    </Col>
                                    <Col xs={12} sm={12} md={"auto"} className="ps-md-0">
                                        <p className="paragraph-small font-divelit-grey-50"><span className="article-slash-padding d-none d-md-inline">/</span>{ parseIsoDatetime(article.created_at, language) }</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12}>
                                        <h2 className="font-divelit-lemon">{ article.title }</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12}>
                                        <div className="mt-1 mt-md-2 mt-lg-4">
                                            <div className="d-flex flex-row">
                                                <div className="flex-column me-3 me-md-4">
                                                    <img src={ setImage(article.author_image) } className="article-container-profile-img float-center float-lg-start" alt={translation.alt.profile_image}/>
                                                </div>
                                                <div className="flex-column align-self-center ">
                                                    <h5 className="mb-0 mb-md-2 font-divelit-grey-50">Autor:</h5>
                                                    <p className="paragraph-small font-white mb-0">{ article.author } ⋅&nbsp;{ article.time_to_read }&nbsp;min</p>   
                                                </div>
                                            </div>
                                        </div>                                        
                                    </Col>
                                </Row>
                                <img src={ setImage(article.main_image) } className="article-hero-img mt-2 mt-md-3 mt-lg-5" alt={translation.alt.article_image}/>
                            </Container>
                        </div>
                        <div className="pt-3 pt-lg-5"></div>
                    </div>

                    <div className="article-background">
                        <div id="article_content" className="container">
                            <div className="row mt-1 mb-5">
                                <div className="col-12 col-lg-10 col-xxl-8 mx-auto">
                                    <img src={square_lime} className="home-experts-img mt-2 mt-md-3 mt-lg-5 mb-2" alt={translation.alt.grass_square}/>

                                    <div className="ws-prewrap" dangerouslySetInnerHTML={createMarkup(article.content)} />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                ) 
                : 
                <></>
            }
        </div>
    );
}
